module.exports = __webpack_public_path__ + "static/media/autopilot-mode-large@2x.0bbb724b.png";